import http from "./core";

const basePath = "api/portal/Auth";


export default {
  sendLink(email) {
    return http.post(`${basePath}/SendLink`, {email});
  },
  auth(patientId, dob, code) {
    return http.post(`${basePath}/Login`, {
      patientId,
      dateOfBirth: dob === "" ? undefined : dob,
      code
    });
  },
  authNewPatient(patientId, dob) {
    return http.post(`${basePath}/LoginWithNewPatient`, {
      patientId,
      dateOfBirth: dob
    });
  },
  getCurrentUser() {
    return http.get(`${basePath}/CurrentUser`);
  },
  refreshToken() {
  }
};

